import {
  Checkbox,
  Flex,
  FlexAnchor,
  mdBumps,
  PrimaryButton,
  Typo,
  xlBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback, useState } from 'react'

import {
  TKey,
  useWriskTranslation,
} from '../../../../../../infrastructure/internationalisation'
import { ProductConfig } from '../../../../../../state/configuration'
import { WriskTrans } from '../../../../../organisms/trans'

const tKey = TKey('components.start-payment')

export const StartPaymentSection: FunctionComponent<{
  product: ProductConfig
  onConfirm: () => void
  loading: boolean
}> = ({ product, onConfirm, loading }) => {
  const { t } = useWriskTranslation()

  const [paymentChecklist, setPaymentChecklist] = useState<Record<string, boolean>>(
    product.paymentChecklist?.reduce((acc, it) => ({ ...acc, [it]: false }), {}) ?? {},
  )

  const onChange = useCallback(
    (id: string) => (checked: boolean) =>
      setPaymentChecklist((current) => ({ ...current, [id]: checked })),
    [setPaymentChecklist],
  )

  const confirmSections = Object.entries(paymentChecklist).map(([id, checked]) => (
    <FlexAnchor
      key={id}
      as='label'
      htmlFor={id}
      backgroundColor='chalk'
      justifyContent='flex-start'
      width={1}
      variant='inset'
      px={mdBumps}
      py={3}
    >
      <Checkbox id={id} mr={4} value={checked} onChange={onChange(id)} />
      <Typo>
        <WriskTrans t={t} i18nKey={tKey('agreements', id)} />
      </Typo>
    </FlexAnchor>
  ))

  return (
    <>
      {confirmSections.length > 0 && (
        <Flex
          width={1}
          py={2}
          mb={xlBumps}
          flexWrap='wrap'
          variant='raised'
          flexDirection='column'
        >
          {confirmSections}
        </Flex>
      )}

      <PrimaryButton
        data-testid='button-continue'
        layout='fixed'
        onClick={onConfirm}
        loading={loading}
        disabled={!Object.values(paymentChecklist).every(Boolean)}
      >
        {t(tKey('actions.continue'))}
      </PrimaryButton>
    </>
  )
}
